import {
  Button,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';

interface CancelPlanStepProps {
  onClose: () => void;
  onConfirm: () => void;
  name: string;
  price: number;
  features: string[];
}

export const CancelPlanStep = ({
  onClose,
  onConfirm,
  name,
  price,
  features,
}: CancelPlanStepProps) => {
  return (
    <div className="w-[660px] max-w-[660px] rounded-lg shadow-3xl">
      <DialogHeader>
        <DialogTitle>Cancel {name}</DialogTitle>
      </DialogHeader>

      <div className="p-3xl space-y-3xl">
        <div className="bg-utility-violet-50 rounded-lg gap-xl p-2xl">
          <div className="flex items-center justify-between">
            <h2 className="text-xl-bold text-text-primary">{name}</h2>
            <div className="flex items-baseline">
              <span className="text-md-bold text-text-primary">${price}</span>
              <span className="text-sm-regular text-text-tertiary ml-1">
                /year
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-xl">
          <h3 className="txt-medium-medium text-text-primary">
            By cancelling {name}, you will miss out on
          </h3>
          <ul className="space-y-3">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-3">
                <Icons.Check className="h-5 w-5 text-fg-success" />
                <span className="text-sm-regular text-text-secondary">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <DialogFooter>
        <Button variant="destructive-secondary" size="md" onClick={onConfirm}>
          I want to cancel
        </Button>
        <Button variant="primary" size="md" onClick={onClose}>
          Keep my plan
        </Button>
      </DialogFooter>
    </div>
  );
};

export default CancelPlanStep;
